// 首页统计数据接口
// 系统管理接口
import commonApi from "./common";
const Api = Object.assign({
  ...commonApi,
});
export default Api;
